module.exports = __webpack_public_path__ + "media/images/TreeGif-b8e67deff583a8ff83b58cf9d7a7aa00.png";